
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/socket.io-client/~/component-inherit/index.js
// module id = 336
// module chunks = 0